import { AddCircle, DeleteForever, RemoveCircle } from '@material-ui/icons';

export const NOTIFICATION_VIEW = 'notification_view';
export const NOTIFICATION_CREATE = 'notification_create';
export const NOTIFICATION_EDIT = 'notification_edit';
export const VALID_DATE_ERROR_MESSAGE =
  'Schedule To date should be greater than schedule From date';
export const STATUS = [
  { id: 'Live', name: 'Live', selected: false },
  { id: 'Scheduled', name: 'Scheduled', selected: false },
  { id: 'Completed', name: 'Completed', selected: false },
  { id: 'Inactive', name: 'Inactive', selected: false },
];
export const NOTIFICATIONS_TYPE = [
  { id: 'F&B', name: 'F&B', selected: false },
  { id: 'IRD', name: 'IRD', selected: false },
  { id: 'Stay', name: 'Stay', selected: false },
  { id: 'Spa', name: 'Spa', selected: false },
  { id: 'Meetings & Events', name: 'Meetings & Events', selected: false },
  { id: 'Weddings', name: 'Weddings', selected: false },
  { id: 'Experience', name: 'Experience', selected: false },
  { id: 'Festive', name: 'Festive', selected: false },
  { id: 'Others', name: 'Others', selected: false },
];
export const RECIPIENT = [
  { id: 'Resident', name: 'Resident', selected: false },
  { id: 'Non-resident', name: 'Non-resident', selected: false },
  { id: 'Both', name: 'Both', selected: false },
];
export const NOTIFICATION_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Type',
    field: 'type',
    subMenu: NOTIFICATIONS_TYPE,
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: STATUS,
  },
  {
    title: 'Recipient',
    field: 'recipient',
    subMenu: RECIPIENT,
  },
];
export const NOTIFICATION_DEVICE = ['Mobile', 'Web', 'Tablet', 'TV'];
export const NOTIFICATION_TAB_LIST = ['Details', 'Schedule', 'Media'];
export const Live = 'Live';
export const Completed = 'Completed';
export const Scheduled = 'Scheduled';
export const Deactivated = 'Inactive';

export const ACTION_MENU_ITEMS = {
  activate: <AddCircle fontSize='small' />,
  deactivate: <RemoveCircle fontSize='small' />,
  delete: <DeleteForever fontSize='small' />,
  export: <img src='/assets/icons/dashboard/export-icon.svg' alt='Export Icon' />,
};
